import { CustomTag } from '@/components/custom-tag/CustomTag';
import clsx from 'clsx';
import React from 'react';

export type TagListProps = {
  tags: string[];
  className?: string;
};

export function TagList(props: TagListProps) {
  const { tags, className } = props;

  const list = React.useMemo(() => {
    return [...new Set(tags)];
  }, [tags]);

  if (!list.length) {
    return null;
  }
  return (
    <div className={clsx('flex flex-wrap gap-1', className)}>
      {list.map((x) => (
        <CustomTag key={x}>{x}</CustomTag>
      ))}
    </div>
  );
}
